var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18 22.006c0 1.84 1.448 3.336 3.23 3.336 1.781 0 3.23-1.496 3.23-3.335 0-1.84-1.449-3.335-3.23-3.335-1.782 0-3.23 1.495-3.23 3.334zM6.41 23.7c-.903 0-1.64-.76-1.64-1.694 0-.933.737-1.693 1.64-1.693.903 0 1.64.76 1.64 1.694 0 .933-.737 1.693-1.64 1.693z",
    fill: "#78C081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41 20.313c.439 0 .795-.367.795-.82V7.95a.808.808 0 0 0-.795-.82.808.808 0 0 0-.795.82v11.542c0 .453.356.82.795.82z",
    fill: "#78C081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41 26.984c-2.662 0-4.82-2.228-4.82-4.977 0-1.713.837-3.225 2.116-4.121a.829.829 0 0 0 .348-.68V4.682c0-1.344 1.055-2.433 2.356-2.433 1.3 0 2.355 1.089 2.355 2.433v12.526c0 .272.13.526.349.679a5.017 5.017 0 0 1 2.115 4.12c0 2.75-2.158 4.978-4.82 4.978zM0 22.007c0 3.655 2.87 6.619 6.41 6.619s6.41-2.964 6.41-6.62c0-2.12-.966-4.006-2.465-5.216V4.68C10.355 2.43 8.59.607 6.41.607c-2.18 0-3.946 1.824-3.946 4.075V16.79A6.688 6.688 0 0 0 0 22.007zM11.946 14.533c0 .454.356.821.795.821h2.464c.439 0 .795-.367.795-.82a.808.808 0 0 0-.795-.822H12.74a.808.808 0 0 0-.795.821zM11.946 11.25c0 .453.356.82.795.82h2.464c.439 0 .795-.367.795-.82a.808.808 0 0 0-.795-.822H12.74a.808.808 0 0 0-.795.821zM11.946 7.965c0 .453.356.82.795.82h2.464c.439 0 .795-.367.795-.82a.808.808 0 0 0-.795-.821H12.74a.808.808 0 0 0-.795.82zM11.946 4.68c0 .454.356.821.795.821h2.464c.439 0 .795-.367.795-.82a.808.808 0 0 0-.795-.821H12.74a.808.808 0 0 0-.795.82z",
    fill: "#78C081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.b6ce7f9f53e21de3a31dc3316187d8cb.svg";
export { ForwardRef as ReactComponent };